/**
 * @generated SignedSource<<39f05ca1163514c7334950d66295266d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespCondensedListedContent_item$data = {
  readonly displayInfo?: {
    readonly ctas: {
      readonly showAcceptOffer: boolean | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedCondensedSidebarButtons_displayInfo" | "PdpSharedPromoCode_displayInfo">;
  } | null;
  readonly firstPhotoWebPath: string | null;
  readonly isAuctionEnabled: boolean | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly skus: ReadonlyArray<{
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpSharedBlurbLeadTime_sku" | "PriceDisplay_sku">;
  } | null> | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"OriginalListPriceLazy_item" | "PdpRespSharedHeroCarousel_item" | "PdpRespTitle_item" | "PdpSharedAuctionCountdownLazy_item" | "PdpSharedBlurbLeadTime_item" | "PdpSharedCondensedAuctionPriceDisplay" | "PdpSharedCondensedSidebarButtons_item" | "PdpSharedCondensedSkuAttributes_item" | "PdpSharedFramingStatus_item" | "PdpSharedShippingBadge_item" | "PdpSharedSidebarFavorites_item" | "PriceDisplay_item">;
  readonly " $fragmentType": "PdpRespCondensedListedContent_item";
};
export type PdpRespCondensedListedContent_item$key = {
  readonly " $data"?: PdpRespCondensedListedContent_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespCondensedListedContent_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Literal",
  "name": "catchNonFatalErrors",
  "value": false
},
v1 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v2 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v3 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v4 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplayOrBtSsr"
    },
    {
      "kind": "RootArgument",
      "name": "fetchAuction"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespCondensedListedContent_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "buyerId",
              "variableName": "userId"
            },
            {
              "kind": "Literal",
              "name": "page",
              "value": "pdp"
            }
          ],
          "concreteType": "ItemDisplayInfo",
          "kind": "LinkedField",
          "name": "displayInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CTADisplay",
              "kind": "LinkedField",
              "name": "ctas",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "showAcceptOffer",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedPromoCode_displayInfo"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpSharedCondensedSidebarButtons_displayInfo"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedFramingStatus_item"
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedBlurbLeadTime_sku"
        },
        {
          "condition": "isMultiSku",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "hasSkuId",
                  "value": true
                },
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "PriceDisplay_sku"
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "condition": "afterDisplayOrBtSsr",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/)
          ],
          "kind": "FragmentSpread",
          "name": "PriceDisplay_item"
        }
      ]
    },
    {
      "condition": "fetchAuction",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedCondensedAuctionPriceDisplay"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedAuctionCountdownLazy_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OriginalListPriceLazy_item"
        }
      ]
    },
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedCondensedSkuAttributes_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingBadge_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTitle_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCondensedSidebarButtons_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbLeadTime_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSidebarFavorites_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "090af51cdeaa532cbe06bea384efd2a8";

export default node;
